<script lang="ts">
  import type { Snippet } from 'svelte'

  type Props = {
    children: Snippet
  }
  let { children }: Props = $props()
</script>

<div class="stat-card-primary">
  {@render children?.()}
</div>

<style lang="scss">
  .stat-card-primary {
    color: var(--foreground);
    display: inline;
    font-weight: 600;
    font-size: 1.25rem;
  }
</style>
